import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';

export default class MetadataLabel extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
  };

  render() {
    // @ts-ignore
    const { styles } = MetadataLabel;

    return (
      // @ts-ignore
      <div className={cx(this.props.className, styles.label)}>
        {this.props.children}
      </div>
    );
  }
}
// @ts-ignore
const styles = cssInJS({
  label: {
    width: '42%',
    paddingLeft: 12,
    paddingTop: 10,
    paddingBottom: 10,

    '@phone': {
      display: 'block',
      width: '100%',
      fontWeight: 'bold',
      paddingTop: 6,
    },
  },
});
// @ts-ignore
MetadataLabel.styles = styles;
